export var UserSortType;
(function (UserSortType) {
    UserSortType[UserSortType["CREATION_DATE_ASC"] = 10] = "CREATION_DATE_ASC";
    UserSortType[UserSortType["CREATION_DATE_DESC"] = 20] = "CREATION_DATE_DESC";
    UserSortType[UserSortType["LAST_UPDATE_DATE_ASC"] = 30] = "LAST_UPDATE_DATE_ASC";
    UserSortType[UserSortType["LAST_UPDATE_DATE_DESC"] = 40] = "LAST_UPDATE_DATE_DESC";
    UserSortType[UserSortType["FIRST_NAME_ASC"] = 50] = "FIRST_NAME_ASC";
    UserSortType[UserSortType["FIRST_NAME_DESC"] = 60] = "FIRST_NAME_DESC";
    UserSortType[UserSortType["EMAIL_ASC"] = 70] = "EMAIL_ASC";
    UserSortType[UserSortType["EMAIL_DESC"] = 80] = "EMAIL_DESC";
    UserSortType[UserSortType["COMPANY_CUSTOMER_PERMISSION_ASC"] = 90] = "COMPANY_CUSTOMER_PERMISSION_ASC";
    UserSortType[UserSortType["COMPANY_CUSTOMER_PERMISSION_DESC"] = 100] = "COMPANY_CUSTOMER_PERMISSION_DESC";
})(UserSortType || (UserSortType = {}));
//# sourceMappingURL=user-sort-type.emun.js.map